module.exports = __webpack_public_path__ + "img/14.a3f3ac25.jpg";